<script setup lang="ts">
import { useRouter } from 'vue-router';
import { ArrowLeft } from '@lucide/vue';
import type { Template } from '@evolfin/shared';
import { useAvvisi } from '@/composables/useAvvisi';
import { useInvalidation } from '@/composables/useInvalidation';
import FormTemplate from '../components/FormTemplate.vue';

definePage({ meta: { titolo: 'Nuovo template', privilegi: ['can_manage_templates'] } });

const router = useRouter();
const avvisi = useAvvisi();
// L'elenco da cui si è arrivati non sa ancora della riga nuova.
const invalidate = useInvalidation('template');

function salvato(template: Template): void {
  void invalidate();
  avvisi.successo('Template creato');
  void router.push(`/template/${template.id}`);
}
</script>

<template>
  <div class="mx-auto flex w-full max-w-2xl flex-col gap-6">
    <div>
      <button
        type="button"
        class="flex w-fit items-center gap-1.5 text-[13px] text-ink-secondary transition-colors hover:text-ink"
        @click="router.push('/template')"
      >
        <ArrowLeft :size="15" :stroke-width="1.9" /> Template
      </button>
      <h1 class="mt-3 font-display text-[28px] leading-tight font-semibold">Nuovo template</h1>
      <p class="mt-1 text-[13px] text-ink-secondary">
        Fasi e documenti attesi si gestiscono dalla scheda del template.
      </p>
    </div>

    <FormTemplate @salvato="salvato" @annulla="router.push('/template')" />
  </div>
</template>
